export default {
    "TXT_APP_Back": "返回",
    "TXT_APP_By": "由",
    "TXT_APP_Continue": "繼續",
    "TXT_APP_Currency_HKD": "港元",
    "TXT_APP_Currency_RMB": "人民幣",
    "TXT_APP_Currency_USD": "美元",
    "TXT_APP_NA": "不適用",
    "TXT_APP_Not_Support_IE": "您的瀏覽器不受支援。請使用Chrome、Edge、Firefox、Safari或QQ瀏覽器瀏覽我們的頁面。謝謝。",
    "TXT_APP_Please_Wait": "請稍候，請勿關閉瀏覽器。",
    "TXT_APP_Remove": "移除",
    "TXT_APP_Submit": "提交",
    "TXT_CHINESE_PAYMENT_NOTIFY": "請注意，交易正在進行中，可能需要比預期更長的時間才能完成。請耐心等待頁面跳轉，並確保不要關閉支付應用程式及支付頁面。",
    "TXT_ERROR_Client_Side_Error": "客戶端發生錯誤",
    "TXT_ERROR_Create_Order": "請重試或稍後再試。",
    "TXT_ERROR_Expired_Package_Not_Allow_To_Pay": "產品連結已不再可用。\n請聯繫您的銷售代表或致電 (852) 1830 668。",
    "TXT_ERROR_Form_Address_First_Row_Invalid": "輸入無效，必須提供英文地址。",
    "TXT_ERROR_Form_Address_First_Row_Missing": "請填寫第一行的地址。",
    "TXT_ERROR_Form_Address_Fourth_Row_Invalid": "輸入無效，必須提供英文地址。",
    "TXT_ERROR_Form_Address_Missing": "請填寫公司地址 (英文)。",
    "TXT_ERROR_Form_Address_Second_Row_Invalid": "輸入無效，必須提供英文地址。",
    "TXT_ERROR_Form_Address_Third_Row_Invalid": "輸入無效，必須提供英文地址。",
    "TXT_ERROR_Form_BR_Commencement_Date_Missing": "請選擇開始日期。",
    "TXT_ERROR_Form_BR_Expiry_Date_Missing": "請選擇到期日期。",
    "TXT_ERROR_Form_BR_Image_Missing": "請上傳商業登記證檔案。",
    "TXT_ERROR_Form_BR_Number_Missing": "請填寫商業登記號碼。",
    "TXT_ERROR_Form_Contact_Person_FN_Invalid": "輸入無效，必須提供英文姓名。",
    "TXT_ERROR_Form_Contact_Person_LN_Invalid": "輸入無效，必須提供英文姓名。",
    "TXT_ERROR_Form_Contact_Person_Missing": "請填寫聯絡人稱謂/姓名。",
    "TXT_ERROR_Form_Email_Invalid": "無效的公司電郵。",
    "TXT_ERROR_Form_Email_Lang_Pref": "請選擇電郵語言偏好。",
    "TXT_ERROR_Form_Email_Missing": "請填寫公司電郵。",
    "TXT_ERROR_Form_General_Invalid": "提供的值無效。",
    "TXT_ERROR_Form_HKBR_Number_Invalid": "無效的商業登記號碼。只允許字符，最多20個字符。",
    "TXT_ERROR_Form_NOB_Missing": "請選擇業務性質。",
    "TXT_ERROR_Form_NOT_HKBR_Number_Invalid": "無效的商業登記號碼。最多20個字符。",
    "TXT_ERROR_Form_Name_EN_Invalid": "公司名稱無效 (英文)。",
    "TXT_ERROR_Form_Name_EN_Missing": "請填寫公司名稱 (英文)。",
    "TXT_ERROR_Form_Name_SC_Invalid": "無效的公司名稱 (簡體中文)。",
    "TXT_ERROR_Form_Name_TC_Invalid": "無效的公司名稱 (繁體中文)。",
    "TXT_ERROR_Form_No_Package_Hashed_ID_Specified": "未指定套餐雜湊ID",
    "TXT_ERROR_Form_No_Sales_Channel_Specified": "未指定銷售渠道",
    "TXT_ERROR_Form_Recaptcha_Not_Checked": "驗證失敗。",
    "TXT_ERROR_Form_Region_City_Invalid": "所選城市與所選省份不符",
    "TXT_ERROR_Form_Region_Country_Missing": "請選擇國家/地區。",
    "TXT_ERROR_Form_Region_Mandatory_City_Missing": "請選擇城市。",
    "TXT_ERROR_Form_Region_Mandatory_State_Missing": "請選擇州/省。",
    "TXT_ERROR_Form_Region_State_Invalid": "所選州份與所選國家不符",
    "TXT_ERROR_Form_Sales_Rep_Code_Invalid": "無效的銷售代表代碼。",
    "TXT_ERROR_Form_Telephone_Area_Cod_Invalid": "無效的電話號碼。",
    "TXT_ERROR_Form_Telephone_Ext_Invalid": "無效的電話號碼。",
    "TXT_ERROR_Form_Telephone_Field_Missing": "請填寫您的電話號碼。",
    "TXT_ERROR_Form_Telephone_Number_Invalid": "無效的電話號碼。",
    "TXT_ERROR_Form_TnC_Missing": "您必須閱讀並同意我們的使用條款才能繼續。",
    "TXT_ERROR_General_Error": "我們遇到了一些技術問題，請稍後重試。\n如有任何疑問，請致電 (852) 1830 668。",
    "TXT_ERROR_Load_Order": "我們遇到了一些技術問題，請稍後重試。\n如有任何疑問，請致電 (852) 1830 668。",
    "TXT_ERROR_Load_Package_With_Error": "我們遇到了一些技術問題，請稍後重試。\n如有任何疑問，請致電 (852) 1830 668。",
    "TXT_ERROR_Not_Able_To_Pay": "我們遇到了一些技術問題，請稍後重試。\n如有任何疑問，請致電 (852) 1830 668。",
    "TXT_ERROR_Order_Status_Not_Allow_To_Pay": "訂單已被取消或拒絕。請致電 (852) 1830 668 或電郵至 online.ordering@hktdc.org",
    "TXT_ERROR_Package_Disabled": "產品連結已不再可用。\n請聯繫您的銷售代表或致電 (852) 1830 668。",
    "TXT_ERROR_Package_Expired": "產品連結已不再可用。\n請聯繫您的銷售代表或致電 (852) 1830 668。",
    "TXT_ERROR_Package_Not_Yet_Start": "產品連結已不再可用。\n請聯繫您的銷售代表或致電 (852) 1830 668。",
    "TXT_ERROR_Page_Not_Found": "404 - 找不到頁面",
    "TXT_ERROR_Payment_Gateway_Error": "很抱歉，付款網關目前無法完成您的付款。請稍後重新提交您的訂單。如有其他查詢，請致電我們的客戶服務熱線 (852) 1830 668 或電郵至 online.ordering@hktdc.org",
    "TXT_ERROR_Payment_Gateway_Query_Payment_Status_Failed": "謝謝您的訂購。我們將核實您的付款並很快向您發送確認電郵。\n如有任何疑問，請致電 (852) 1830 668",
    "TXT_ERROR_Server_Side_Error": "伺服器發生<statusCode>錯誤",
    "TXT_ERROR_Update_Order": "請重試或稍後再試。",
    "TXT_ERROR_User_Block_Popup": "請停用彈出視窗阻擋程式並重新點擊超連結。",
    "TXT_LANDING_Agree_Desc": "我同意除非我取消自動續約，否則已訂閱的套餐將在目前訂閱期屆滿前代表我自動續約。",
    "TXT_LANDING_Company_Info": "公司資料",
    "TXT_LANDING_Confirm_Payment_Message": "根據我們的記錄，我們已收到您的全額付款，確認電郵將很快發送給您。",
    "TXT_LANDING_Confirm_Privacy_Policy_Statement": "私隱政策聲明",
    "TXT_LANDING_Confirm_Proceed_Payment_Btn": "確認並進行付款",
    "TXT_LANDING_Confirm_Terms_And_Conditions_For_HKTDC": "香港貿發局廣告、廣告相關服務及活動現場廣告項目的條款及細則",
    "TXT_LANDING_Confirm_Terms_Of_Use": "使用條款",
    "TXT_LANDING_Confirm_Terms_Of_Use_And_Symbol": "及",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text1": "http://www.hktdc.com/mis/tu/en/Terms-of-Use.html",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text2_Part1": "info.hktdc.com/",
    "TXT_LANDING_Confirm_Terms_Of_Use_Link_Text2_Part2": "promotion_terms/index.htm",
    "TXT_LANDING_Confirm_Terms_Part1": "我確認已閱讀並同意香港貿易發展局(香港貿發局)的",
    "TXT_LANDING_Confirm_Terms_Part2": "，並確認上述資料可由香港貿發局納入其全部或任何資料庫，用作直接營銷或商業配對目的，以及",
    "TXT_LANDING_Done_Btn": "完成",
    "TXT_LANDING_Done_Btn_Url": "https://sourcingsupport.hktdc.com/hc/zh-hk",
    "TXT_LANDING_Fields_BR_Number": "商業登記號碼",
    "TXT_LANDING_Fields_Commencement_Date": "開始日期",
    "TXT_LANDING_Fields_Email": "公司電郵",
    "TXT_LANDING_Fields_Expiry_Date": "到期日期",
    "TXT_LANDING_Fields_Name": "公司名稱 (英文名稱)",
    "TXT_LANDING_Fields_Name_SC": "公司名稱 (簡體中文)",
    "TXT_LANDING_Fields_Name_TC": "公司名稱 (繁體中文)",
    "TXT_LANDING_Fields_Provide_BR_Details": "現在可提供商業登記詳情",
    "TXT_LANDING_Fields_Provide_BR_Details_Msg": "您亦可在訂購套餐之後補回商業登記詳情及上傳商業登記證。",
    "TXT_LANDING_From_Address_En": "公司地址 (英文地址)",
    "TXT_LANDING_From_City": "城市",
    "TXT_LANDING_From_Contact_Person_Name": "聯絡人姓名 (請輸入英文姓名)",
    "TXT_LANDING_From_Desc1": "請填寫訂購表格。",
    "TXT_LANDING_From_Desc2": "如果您是由我們的銷售代表轉介，請在下方輸入銷售代表代碼。",
    "TXT_LANDING_From_Email_Lang_Option": "電郵語言偏好",
    "TXT_LANDING_From_Nature_Of_Business": "業務性質",
    "TXT_LANDING_From_Region": "國家/地區",
    "TXT_LANDING_From_Sales_Code": "銷售代表代碼",
    "TXT_LANDING_From_State": "州/省",
    "TXT_LANDING_From_Tel": "電話",
    "TXT_LANDING_Hints_Required": "必填資料",
    "TXT_LANDING_Logo_Link_Url": "https://sourcing.hktdc.com/zh-Hant",
    "TXT_LANDING_Media_Modal_Title": "查看已上傳的商業登記證檔案",
    "TXT_LANDING_Modal_Acceptable": "只接受JPG和PDF檔案。檔案大小最大5MB。",
    "TXT_LANDING_Modal_Cancel_Upload": "取消上傳",
    "TXT_LANDING_Modal_Choose_File": "選擇檔案",
    "TXT_LANDING_Modal_Contact_Message": "您的付款交易無法完成。\n請致電 (852) 1830 668 或電郵至\nonline.ordering@hktdc.org",
    "TXT_LANDING_Modal_Drap_N_Drop": "或拖放檔案",
    "TXT_LANDING_Modal_Message_Upload_Failed": "我們只接受JPG、JPEG和PDF檔案格式，檔案大小最大5MB，請重試。",
    "TXT_LANDING_Modal_Upload_Again": "重新上傳",
    "TXT_LANDING_Modal_Upload_Failed": "上傳失敗",
    "TXT_LANDING_Modal_Uploading": "上傳中...",
    "TXT_LANDING_Modal_Verify_Card_Message": "您的付款交易無法完成。\n請核實您的信用卡詳情並重試。",
    "TXT_LANDING_Ok_Btn_Title": "確定",
    "TXT_LANDING_Order_ID_Display": "訂單編號",
    "TXT_LANDING_PH_Address_Unit": "房間 / 單位 / 樓層 / 座",
    "TXT_LANDING_PH_Area_Code": "區號 (如有)",
    "TXT_LANDING_PH_BR_Number": "商業登記號碼",
    "TXT_LANDING_PH_Building": "大廈",
    "TXT_LANDING_PH_City": "區 / 市 / 州 / 省 / 國家",
    "TXT_LANDING_PH_Date": "日日 月月 年年年年",
    "TXT_LANDING_PH_Email": "公司電郵",
    "TXT_LANDING_PH_Extension": "分機 (如有)",
    "TXT_LANDING_PH_First_Name": "名",
    "TXT_LANDING_PH_Last_Name": "姓",
    "TXT_LANDING_PH_Name": "公司名稱 (英文)",
    "TXT_LANDING_PH_Name_SC": "公司名稱 (簡體中文)",
    "TXT_LANDING_PH_Name_TC": "公司名稱 (繁體中文)",
    "TXT_LANDING_PH_Select": "請選擇",
    "TXT_LANDING_PH_Street": "街道 / 道路",
    "TXT_LANDING_PH_Tel_Number": "電話號碼",
    "TXT_LANDING_Package_Details": "套餐詳情",
    "TXT_LANDING_Package_Period_Month": "個月",
    "TXT_LANDING_Package_Period_Month_Lower_Letter": "個月",
    "TXT_LANDING_Package_Period_Months": "個月",
    "TXT_LANDING_Package_Period_Months_Lower_Letter": "個月",
    "TXT_LANDING_Package_Prices_Notice": "價格因國家或地區而異",
    "TXT_LANDING_Package_View_More": "查看套餐詳情",
    "TXT_LANDING_Page_Title": "訂購網上推廣計劃",
    "TXT_LANDING_Payment_Failed_Modal_Title": "付款失敗",
    "TXT_LANDING_Payment_Link_Expired": "付款連結已過期。",
    "TXT_LANDING_Payment_Method": "付款方式",
    "TXT_LANDING_Please_Call_Us_Message": "請致電 (852) 1830 668 或電郵至 online.ordering@hktdc.org",
    "TXT_LANDING_Privacy_Policy_Statement_Link_Url": "http://www.hktdc.com/mis/pps/en/Privacy-Policy-Statement.html",
    "TXT_LANDING_Proceed_Payment_Btn": "進行付款",
    "TXT_LANDING_Sales_Contact_Message": "您的專屬銷售代表將很快與您聯繫。",
    "TXT_LANDING_Scheduled_Payment_Message": "我們已收到您的預定付款指示，電郵通知將很快發送給您。",
    "TXT_LANDING_Subscription_Approved_Desc": "謝謝您的付款。您的訂購正等待核實。",
    "TXT_LANDING_Summary_Form_Proceed_Btn": "進行付款",
    "TXT_LANDING_Summary_From_BRN": "商業登記號碼",
    "TXT_LANDING_Summary_From_Commencement_Date": "開始日期",
    "TXT_LANDING_Summary_From_Currency_Paid_Way": "付款貨幣",
    "TXT_LANDING_Summary_From_Exchange_Rate_Desc": "**匯率可能會有變動**",
    "TXT_LANDING_Summary_From_Expiry_Date": "到期日期",
    "TXT_LANDING_Summary_From_Title": "訂單摘要",
    "TXT_LANDING_Summary_From_Total_Amount": "總付款金額",
    "TXT_LANDING_Summary_Payment_Details_Currency": "HKD",
    "TXT_LANDING_Term_Of_Use_Link_Url1": "http://www.hktdc.com/mis/tu/en/Terms-of-Use.html",
    "TXT_LANDING_Term_Of_Use_Link_Url2": "http://info.hktdc.com/promotion_terms/index.htm",
    "TXT_LANDING_Thankyou_Currency_Paid_Way": "付款貨幣",
    "TXT_LANDING_Timer_Modal_Title": "逾時",
    "TXT_LANDING_Unavailable_Page_Here": "這裡",
    "TXT_LANDING_Unavailable_Page_Prefix": "頁面不可用。請點擊",
    "TXT_LANDING_Unavailable_Page_Suffix": "再次提交您的訂單。",
    "TXT_LANDING_Upload_Constraint": "上傳商業登記證檔案 (最大 5MB)",
    "TXT_ONLINE_FORM_Aria_Label_Appellation_Select_Input": "稱謂選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_BR_Cancel_Upload_Input": "取消上傳檔案",
    "TXT_ONLINE_FORM_Aria_Label_BR_Choose_Files_Input": "選擇商業登記證檔案",
    "TXT_ONLINE_FORM_Aria_Label_BR_Commencement_Date_Input": "輸入商業登記證開始日期",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Remove_Uploaded_Files_Btn": "移除已上傳檔案",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Switch_Btn": "開啟/關閉商業登記證部分",
    "TXT_ONLINE_FORM_Aria_Label_BR_Details_Upload_Files_Btn": "上傳商業登記證檔案",
    "TXT_ONLINE_FORM_Aria_Label_BR_Expiry_Date_Input": "輸入商業登記證到期日期",
    "TXT_ONLINE_FORM_Aria_Label_BR_Number_Input": "輸入商業登記證號碼",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row1_Input": "輸入地址房間/單位/樓層/座",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row2_Input": "輸入地址大廈",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row3_Input": "輸入地址街道/道路",
    "TXT_ONLINE_FORM_Aria_Label_Company_Address_Row4_Input": "輸入地址區/市/州/省/國家",
    "TXT_ONLINE_FORM_Aria_Label_Company_City_Input": "城市選單",
    "TXT_ONLINE_FORM_Aria_Label_Company_Email_Input": "輸入電郵",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_EN_Input": "輸入英文公司名稱",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_SC_Input": "輸入簡體中文公司名稱",
    "TXT_ONLINE_FORM_Aria_Label_Company_Name_TC_Input": "輸入繁體中文公司名稱",
    "TXT_ONLINE_FORM_Aria_Label_Company_Region_Input": "地區選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_Company_State_Input": "州選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_Contact_Sale_Popup": "付款失敗並聯絡銷售",
    "TXT_ONLINE_FORM_Aria_Label_Details_Back_Btn": "返回首頁",
    "TXT_ONLINE_FORM_Aria_Label_Details_Google_Recaptcha": "驗證碼",
    "TXT_ONLINE_FORM_Aria_Label_Details_Preview_File_Popup": "預覽檔案彈窗",
    "TXT_ONLINE_FORM_Aria_Label_Details_Submit_Form_Btn": "提交表格",
    "TXT_ONLINE_FORM_Aria_Label_Details_Tencent_Captcha": "騰訊驗證碼",
    "TXT_ONLINE_FORM_Aria_Label_Details_Upload_Fail_Popup": "上傳失敗彈窗",
    "TXT_ONLINE_FORM_Aria_Label_Details_Upload_File_Popup": "上傳檔案彈窗",
    "TXT_ONLINE_FORM_Aria_Label_Email_Lang_Ref_Input": "電郵語言選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_Failure_Back_Btn": "返回摘要頁面",
    "TXT_ONLINE_FORM_Aria_Label_Failure_Confirm_Btn": "處理並確認付款",
    "TXT_ONLINE_FORM_Aria_Label_First_Name_Input": "輸入名字",
    "TXT_ONLINE_FORM_Aria_Label_Header_Logo": "連結至貿發局網站",
    "TXT_ONLINE_FORM_Aria_Label_Landing_Continue_Btn": "繼續按鈕",
    "TXT_ONLINE_FORM_Aria_Label_Last_Name_Input": "輸入姓氏",
    "TXT_ONLINE_FORM_Aria_Label_NOB_Input": "業務性質選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Area_Code_Input": "輸入電話區號",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Country_Code_Input": "電話國家代碼選擇清單",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Extension_Input": "輸入電話分機",
    "TXT_ONLINE_FORM_Aria_Label_Phone_Number_Input": "輸入電話號碼",
    "TXT_ONLINE_FORM_Aria_Label_Retry_Payment_Popup": "付款失敗並重試",
    "TXT_ONLINE_FORM_Aria_Label_Sales_Code_Input": "輸入銷售代碼",
    "TXT_ONLINE_FORM_Aria_Label_Summary_Back_Btn": "返回詳情頁面",
    "TXT_ONLINE_FORM_Aria_Label_Summary_Confirm_Btn": "處理並確認付款",
    "TXT_ONLINE_FORM_Aria_Label_Thankyou_Done_Btn": "付款完成",
    "TXT_ONLINE_FORM_Meta_Description_Title_Contact_Sale": "SPCS網上訂閱表格 - 聯絡銷售",
    "TXT_ONLINE_FORM_Meta_Description_Title_Details": "SPCS網上訂閱表格 - 詳細資料",
    "TXT_ONLINE_FORM_Meta_Description_Title_Discount_Listing": "SPCS管理員門戶 - 折扣清單",
    "TXT_ONLINE_FORM_Meta_Description_Title_Error": "SPCS網上訂閱表格 - 錯誤",
    "TXT_ONLINE_FORM_Meta_Description_Title_Failure": "SPCS網上訂閱表格 - 錯誤",
    "TXT_ONLINE_FORM_Meta_Description_Title_Gen_link": "SPCS管理員門戶 - 生成私人連結",
    "TXT_ONLINE_FORM_Meta_Description_Title_Index": "SPCS網上訂閱表格 - 基本資料",
    "TXT_ONLINE_FORM_Meta_Description_Title_Order_Management": "SPCS管理員門戶 - 訂單管理",
    "TXT_ONLINE_FORM_Meta_Description_Title_Product_Listing": "SPCS管理員門戶 - 產品清單",
    "TXT_ONLINE_FORM_Meta_Description_Title_Summary": "SPCS網上訂閱表格 - 訂單摘要",
    "TXT_ONLINE_FORM_Meta_Description_Title_Thankyou": "SPCS網上訂閱表格 - 謝謝",
    "TXT_ONLINE_FORM_Meta_Description_Title_User_Management": "SPCS管理員門戶 - 用戶帳戶管理",
    "TXT_ONLINE_FORM_Meta_Head_Description": "SPCS網上訂閱表格 - 基本資料",
    "TXT_ONLINE_FORM_Meta_Head_Title": "香港貿發局網上表格",
    "TXT_ONLINE_FORM_Meta_Head_Title_Contact_Sale": "聯絡銷售",
    "TXT_ONLINE_FORM_Meta_Head_Title_Details": "詳細資料",
    "TXT_ONLINE_FORM_Meta_Head_Title_Error": "錯誤",
    "TXT_ONLINE_FORM_Meta_Head_Title_Failure": "付款失敗",
    "TXT_ONLINE_FORM_Meta_Head_Title_Index": "基本資料",
    "TXT_ONLINE_FORM_Meta_Head_Title_Summary": "訂單摘要",
    "TXT_ONLINE_FORM_Meta_Head_Title_Thankyou": "謝謝",
    "TXT_SUBSCRIPTION_Page_Title": "謝謝您的訂單！",
    "TXT_Summary_From_Contact_Person_Name": "聯絡人姓名 (英文姓名)",
    "TXT_WF_User_TnC_Html": "我/我們同意並確認，本合約、下文所定之條款及細則，以及我/我們就上述香港貿發局活動所簽署或提交的所有後續文件，對我/我們均具有約束力。本合約須經香港貿發局接受及確認，香港貿發局擁有絕對酌情權。我/我們確認並同意，香港貿發局可將上述資料用於納入其全部或任何資料庫，作直接推廣或商貿配對之用，及用於私隱政策聲明中所述的任何其他用途。</br></br>\n <strong>條款及細則：</strong></br>\n <ol class=\"custom-list\"> \n <li>香港貿發局廣告、相關廣告服務及活動現場廣告項目的條款及細則（香港貿發局可不時修訂或補充），詳見附件及香港貿發局網站 <a href=\"https://home.hktdc.com/tc/s/sourcing-promotion-terms\" target=\"_blank\">https://home.hktdc.com/tc/s/sourcing-promotion-terms</a>；</li> \n <li>香港貿發局展覽會現場廣告項目申請條款（香港貿發局可不時修訂或補充），詳見附件及香港貿發局網站 <a href=\"https://info.hktdc.com/sourcing/onsite-ad-application-terms/\" target=\"_blank\">https://info.hktdc.com/sourcing/onsite-ad-application-terms/</a>；</li> <li>申請條款及展覽規則與規例（香港貿發局可不時修訂或補充），詳見香港貿發局網站 <a href=\"https://exhmultifairs.hktdc.com/exh/Rules_and_Regulations/index.html\" target=\"_blank\">https://exhmultifairs.hktdc.com/exh/Rules_and_Regulations/index.html</a>；及</li> <li>香港貿發局網站(<a href=\"https://www.hktdc.com/\" target=\"_blank\">https://www.hktdc.com/</a>)上的任何其他條款及細則（香港貿發局可不時修訂或補充）</li> \n </ol> \n </br>((i) 至 (iv) 統稱為「<strong>條款及細則</strong>」)"
};